import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BlogProvider } from './context'
import { ProductProvider } from './productcontext'
import { BrowserRouter as Router } from 'react-router-dom'

ReactDOM.render(
    <Router>
        <BlogProvider>
            <ProductProvider>
                <App />
            </ProductProvider>
        </BlogProvider>
    </Router>
    , document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
